import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import bindActionCreators from '../../../lib/utils/bindActionCreators'

import { ppsSelector } from '../../../selectors'
import { ppsAction } from '../../../actions'

import DataDisplayTab from '../../../components/project-profit-sheet/DataDisplayTab'

const mapStateToProps = createStructuredSelector({
  activeTab: ppsSelector.display,
  privileged: ppsSelector.privileged,
})

const mapDispatchToProps = bindActionCreators({
  onChangeTab: ppsAction.changeDisplayTab,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataDisplayTab)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/ProfitDisplayTab.js